/**
 * Copyright © Veeam Software Group GmbH.
 */

export const baseUrl = '/uiapi/';
